import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { appAction } from "../../actions/app.action";
import { portfolioAction } from "../../actions/portfolio.action";

import {
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Select,
  Slider,
  withStyles,
} from "@material-ui/core";


import PercentageNumber from "../../components/UI/PercentageNumber";
import { userAction } from "../../actions/user.action";
import { advisorConfigFields, ssiConfig } from "../../utilities/constant";
import CurrencyNumber from "../../components/UI/CurrencyNumber";
import SectionHeader from "../../components/UI/SectionHeader";
import { householdAction } from "../../actions/household.action";
import { isMobile } from "../../utilities/mobile";
import Fade from "@material-ui/core/Fade";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import feeAction from "../../actions/fee.action";
import { BaseTooltip } from "../../components/BaseComponents";
import { CyManagerTypes } from "../../utilities/managerTypes";
import { isBasicView } from "../../utilities/access";

const styles = (theme) => ({
  contentWrapper: {
    width: "100%",
    display: `flex`,
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      paddingLeft: "5%",
    },
  },
  row: {
    display: "block",
    flexWrap: "wrap",
  },
  expansionPanel: {
    background: "transparent",
    margin: 0,
  },
  expansionPanelExpanded: {
    margin: 0,
  },
  expansionPanelSummary: {
    padding: 0,
    minHeight: 1,
  },
  expansionPanelSummaryExpanded: {
    padding: 0,
    minHeight: 1,
  },
  expansionPanelDetails: {
    padding: "20px 0 10px",
    position: "relative",
  },
  line: {
    fontSize: 20,
    [theme.breakpoints.down("md")]: {
      fontSize: 16,
      lineHeight: 1,
    },
    margin: 0,
    "& > span": {
      color: theme.palette.primary.main,
    },
    "&.locked": {
      [theme.breakpoints.down("md")]: {
        fontSize: 10,
      },
      padding: `8px 0`,
      "& span": {
        color: theme.palette.grey[600],
      },
    },
    "&.fontAdjusted": {
      [theme.breakpoints.down("md")]: {
        fontSize: 10,
      },
    },
  },
  sliderLegend: {
    width: "80%",
    height: "10px",
    position: "absolute",
    top: 0,
    display: "flex",
    justifyContent: "space-between",
  },
  sliderLegendNum: {
    width: "70px",
    fontSize: 14,
    textAlign: "center",
    "&:not(:first-child):not(:last-child)": {
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
  },
  slider: {
    maxWidth: "calc(80% - 54px)",
    marginLeft: "27px",
  },
  advisorConfigSaveBtn: {
    float: "right",
    marginTop: 20,
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
  lineCompounded: {
    fontSize: 20,
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
    margin: 0,
    padding: `6px 0`,
  },
  smallSelect: {
    marginLeft: 10,
    color: theme.palette.primary.main,
    "& .MuiSelect-root": {
      fontSize: 20,
      [theme.breakpoints.down("md")]: {
        fontSize: 16,
      },
    },
  },
  tooltip: {
    background: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey["A200"]}`,
    color: theme.palette.grey["A400"],
    boxShadow: theme.shadows[1],
    opacity: 1,
    fontSize: 14,
  },
  hintIcon: {
    fontSize: 18,
    margin: "4px 10px",
  },
});

class AdvisorSettings extends React.Component {
  state = {
    isPhone: isMobile.phone(),
    portfolioId: null,
    advisorConfig: {
      ...(this.props.user.user.advisorConfig
        ? this.props.user.user.advisorConfig
        : this.props.user.advisorConfig),
      ...ssiConfig,
    },
    saveBtnLabel: "SAVE",
    baseAdvisorFee: this.props.advisorFeeRate,
  };

  toggleExpansion = (name) => (event, expanded) => {
    this.setState({
      expanded: expanded ? name : false,
    });
  };

  updateAdvisorSetting = (payload) => {
    let newState = Object.assign({}, this.state.advisorConfig);
    let newValue;

    if (payload.portfolio) {
      if (payload.booleanValue) {
        newValue = payload.event.target.checked;
      } else {
        newValue = payload.event.target.value;
      }
    } else {
      newValue = Math.round(payload.value * 1000) / 1000;
    }
    // this.controlBackTestedCheckbox(payload, newValue, newState);
    newState[payload.field] = newValue;
    this.props.dispatch(
      userAction.updateAdvisorConfig({ advisorConfig: newState })
    );
  };

  // Created by Kate
  // Function to check if field is managerType && value is 'WBI only',
  // and make the check marked.
  // If the previous manager type was NOT 'WBI Only', checkbox remains unchanged.
  controlBackTestedCheckbox = (payload, newValue, newState) => {
    const { advisorConfig } = this.state;
    if (payload.field === "managerType") {
      if (newValue === "WBI Blend") {
        newState.includeTheoretical = true;
      } else {
        if (advisorConfig.managerType === "WBI Blend") {
          newState["includeTheoretical"] = false;
        }
      }
    }
  };

  saveAdvisorSetting = () => {
    let newState = Object.assign({}, this.state.advisorConfig);
    this.setState(
      {
        saveBtnLabel: "SAVED",
      },
      () => {
        this.props.dispatch(
          userAction.saveAdvisorSetting({ advisorConfig: newState })
        );
        this.props.dispatch(
          feeAction.updateAdvisorRate(this.state.baseAdvisorFee)
        );
      }
    );
  };

  updateBaseAdvisorFee = (event, newValue) => {
    this.setState({
      baseAdvisorFee: newValue,
    });
  };

  componentDidMount() {
    this.props.dispatch(portfolioAction.clearCurrentPortfolio());
    this.props.dispatch(householdAction.clearCurrentHousehold());
    this.props.dispatch(appAction.setUsersNav(true));
    this.props.dispatch(appAction.toggleMainNav(false));
    window.scrollTo(0, 0);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let orgAdvisorConfig = this.props.user.user.advisorConfig
      ? this.props.user.user.advisorConfig
      : this.props.user.advisorConfig;
    let newAdvisorConfig = nextProps.user.user.advisorConfig
      ? nextProps.user.user.advisorConfig
      : nextProps.user.advisorConfig;

    if (JSON.stringify(orgAdvisorConfig) !== JSON.stringify(newAdvisorConfig)) {
      this.setState({
        advisorConfig: { ...newAdvisorConfig, ...ssiConfig },
        saveBtnLabel: "SAVE",
      });
    }
  }

  render() {
    const { classes, user, accessLevel, appName, advisorDefaultFeeRate } = this.props;
    const { expanded, advisorConfig, baseAdvisorFee } = this.state;
    if (!advisorConfig) return null;
    const supportedManagerTypes = CyManagerTypes.getManagerTypes(appName, user.user.approved);
    return (
      <Fade in>
        <div className={classes.contentWrapper}>
          <div className={classes.content}>
            <SectionHeader text={"Advisor Settings"} />
            <Typography variant={"caption"}>
              Changes will apply from the current business day, going forward.
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                {advisorConfigFields
                  .filter((field) => field.fieldName.indexOf("taxRate") === -1)
                  .map((f, i) => {
                    return (
                      <div className={classes.row} key={i}>
                        <Accordion
                          classes={{
                            root: classes.expansionPanel,
                            expanded: classes.expansionPanelExpanded,
                          }}
                          expanded={expanded === f.fieldName}
                          onChange={this.toggleExpansion(f.fieldName)}
                          elevation={0}
                          square={true}
                        >
                          <AccordionSummary
                            classes={{
                              root: classes.expansionPanelSummary,
                              expanded: classes.expansionPanelSummaryExpanded,
                            }}
                          >
                            {f.valueFormat === "percentage" && (
                              <p
                                className={classes.line}
                                dangerouslySetInnerHTML={{
                                  __html: f.line.replace(
                                    "%",
                                    `${(
                                      advisorConfig[f.fieldName] * 100
                                    ).toFixed(2)}%`
                                  ),
                                }}
                              />
                            )}
                            {f.valueFormat === "number" && (
                              <p
                                className={classes.line}
                                dangerouslySetInnerHTML={{
                                  __html: f.line.replace(
                                    "%",
                                    advisorConfig[f.fieldName]
                                  ),
                                }}
                              />
                            )}
                          </AccordionSummary>
                          <AccordionDetails
                            className={classes.expansionPanelDetails}
                          >
                            <div className={classes.sliderLegend}>
                              {f.valueFormat === "percentage" &&
                                Array(f.sliderParam.tickNumber)
                                  .fill("")
                                  .map((el, index) => {
                                    return (
                                      <div
                                        className={classes.sliderLegendNum}
                                        key={"el" + index}
                                      >
                                        <PercentageNumber
                                          value={
                                            ((f.sliderParam.max -
                                                f.sliderParam.min) /
                                              (f.sliderParam.tickNumber - 1)) *
                                            index +
                                            f.sliderParam.min
                                          }
                                        />
                                      </div>
                                    );
                                  })}
                              {f.valueFormat === "number" &&
                                Array(f.sliderParam.tickNumber)
                                  .fill("")
                                  .map((el, index) => {
                                    return (
                                      <div
                                        className={classes.sliderLegendNum}
                                        key={"el" + index}
                                      >
                                        {((f.sliderParam.max -
                                              f.sliderParam.min) /
                                            (f.sliderParam.tickNumber - 1)) *
                                          index +
                                          f.sliderParam.min}
                                      </div>
                                    );
                                  })}
                            </div>
                            <Slider
                              className={classes.slider}
                              value={advisorConfig[f.fieldName]}
                              name={f.fieldName}
                              min={f.sliderParam.min}
                              max={f.sliderParam.max}
                              step={f.sliderParam.step}
                              onChange={(e, v) =>
                                this.updateAdvisorSetting({
                                  field: f.fieldName,
                                  value: v,
                                  event: e,
                                })
                              }
                            />
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    );
                  })}
                <div className={classes.row}>
                  <div className={`${classes.lineCompounded}`}>
                    Strategy Type
                    <Select
                      native
                      className={classes.smallSelect}
                      value={advisorConfig.managerType}
                      onChange={(e, v) =>
                        this.updateAdvisorSetting({
                          field: "managerType",
                          value: v,
                          event: e,
                          portfolio: true,
                        })
                      }
                      inputProps={{
                        name: "managerType",
                      }}
                    >
                      {
                        supportedManagerTypes.map(m => (<option key={m.code} value={m.code}>{m.name}</option>))
                      }
                    </Select>
                  </div>
                </div>
                <div className={classes.row}>
                  <div className={`${classes.lineCompounded}`}>
                    Risk Selection
                    <Select
                      native
                      className={classes.smallSelect}
                      value={advisorConfig.riskPeriod}
                      onChange={(e, v) =>
                        this.updateAdvisorSetting({
                          field: "riskPeriod",
                          value: v,
                          event: e,
                          portfolio: true,
                        })
                      }
                      inputProps={{
                        name: "riskPeriod",
                      }}
                    >
                      <option value="worst.calendar.year">
                        Worst Calendar Year
                      </option>
                      <option value="worst.4q">Worst Four Quarters</option>
                      <option value="mdd">Worst Drawdown</option>
                    </Select>
                  </div>
                </div>
                <div className={classes.row}>
                  <p className={`${classes.line} locked`}>
                    Social Security Wage Base{" "}
                    <span>
                      <CurrencyNumber value={advisorConfig.ssiBase} />
                    </span>
                  </p>
                </div>
                <div className={classes.row}>
                  <p className={`${classes.line} locked`}>
                    Social Security Max Benefit at FRA{" "}
                    <span>
                      <CurrencyNumber
                        value={advisorConfig.ssiMaxBenefitAtFRA}
                      />
                    </span>
                  </p>
                </div>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant={"h6"} style={{ marginTop: 8 }}>
                  Effective Tax Rates <small>(Fed + State)</small>
                </Typography>
                {advisorConfigFields
                  .filter((field) => field.fieldName.indexOf("taxRate") >= 0)
                  .map((f, i) => {
                    return (
                      <div className={classes.row} key={i}>
                        <Accordion
                          classes={{
                            root: classes.expansionPanel,
                            expanded: classes.expansionPanelExpanded,
                          }}
                          expanded={expanded === f.fieldName}
                          onChange={this.toggleExpansion(f.fieldName)}
                          elevation={0}
                          square={true}
                        >
                          <AccordionSummary
                            classes={{
                              root: classes.expansionPanelSummary,
                              expanded: classes.expansionPanelSummaryExpanded,
                            }}
                          >
                            <BaseTooltip
                              labelComponent={
                                f.valueFormat === "percentage" && (
                                  <p
                                    className={classes.line}
                                    dangerouslySetInnerHTML={{
                                      __html: f.altLine.replace(
                                        "%",
                                        `${(
                                          advisorConfig[f.fieldName] * 100
                                        ).toFixed(2)}%`
                                      ),
                                    }}
                                  />
                                )
                              }
                              helperText={`${appName} currently defaults to a 21.20% tax rate based upon an assumed weighted average blend of tax rates applicable to ordinary income, short-term capital gains, long-term capital gains and qualified dividends.  The tax rates and weights used to create this blend will not apply to all clients but are considered to be an approximate value, that may be used for required rate of return estimation.  Further information about how this blend was determined is available upon request and you have the ability to adjust these values at any time as well as for each client individually.`}
                              placement="top-start"
                              showTooltip={f.fieldName === "taxRateBR" ||
                                f.fieldName === "taxRateIR"}
                            />
                          </AccordionSummary>
                          <AccordionDetails
                            className={classes.expansionPanelDetails}
                          >
                            <div className={classes.sliderLegend}>
                              {f.valueFormat === "percentage" &&
                                Array(f.sliderParam.tickNumber)
                                  .fill("")
                                  .map((el, index) => {
                                    return (
                                      <div
                                        className={classes.sliderLegendNum}
                                        key={"el" + index}
                                      >
                                        <PercentageNumber
                                          value={
                                            ((f.sliderParam.max -
                                                f.sliderParam.min) /
                                              (f.sliderParam.tickNumber - 1)) *
                                            index +
                                            f.sliderParam.min
                                          }
                                        />
                                      </div>
                                    );
                                  })}
                            </div>
                            <Slider
                              className={classes.slider}
                              value={advisorConfig[f.fieldName]}
                              name={f.fieldName}
                              min={f.sliderParam.min}
                              max={f.sliderParam.max}
                              step={f.sliderParam.step}
                              onChange={(e, v) =>
                                this.updateAdvisorSetting({
                                  field: f.fieldName,
                                  value: v,
                                  event: e,
                                })
                              }
                            />
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    );
                  })}

                {!isBasicView(accessLevel) && (
                  <React.Fragment>
                    <Typography variant={"h6"} style={{ marginTop: 24 }}>
                      Advisor Fee
                    </Typography>
                    <div className={classes.row}>
                      <Accordion
                        classes={{
                          root: classes.expansionPanel,
                          expanded: classes.expansionPanelExpanded,
                        }}
                        expanded={expanded === "baseAdvisorFee"}
                        onChange={this.toggleExpansion("baseAdvisorFee")}
                        elevation={0}
                        square={true}
                      >
                        <AccordionSummary
                          classes={{
                            root: classes.expansionPanelSummary,
                            expanded: classes.expansionPanelSummaryExpanded,
                          }}
                        >
                          <BaseTooltip
                            labelComponent={
                              <p
                                className={classes.line}
                                dangerouslySetInnerHTML={{
                                  __html: "Base Advisor Fee <span>%</span>".replace(
                                    "%",
                                    `${baseAdvisorFee === null ? advisorDefaultFeeRate.toFixed(2) : baseAdvisorFee.toFixed(2) }%`
                                  ),
                                }}
                              />
                            }
                            helperText="Fee discount may be applied to individual portfolios. Discounts will be subtracted
                            from the Base Advisor Fee to provide a reduced net fee."
                            placement="top-start"
                          />
                        </AccordionSummary>
                        <AccordionDetails className={classes.expansionPanelDetails}>
                          <div className={classes.sliderLegend}>
                            {Array(8)
                              .fill("")
                              .map((el, index) => {
                                return (
                                  <div
                                    className={classes.sliderLegendNum}
                                    key={"el" + index}
                                  >
                                    <PercentageNumber
                                      value={(0.25 / 100) * index}
                                    />
                                  </div>
                                );
                              })}
                          </div>
                          <Slider
                            className={classes.slider}
                            value={baseAdvisorFee === null ? advisorDefaultFeeRate : baseAdvisorFee}
                            name="baseAdvisorFee"
                            min={0}
                            max={1.75}
                            step={0.05}
                            onChange={this.updateBaseAdvisorFee}
                          />
                        </AccordionDetails>
                      </Accordion>
                    </div>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.advisorConfigSaveBtn}
                      onClick={this.saveAdvisorSetting.bind(this, false)}
                    >
                      {this.props.user.advisorConfigUpdating ? (
                        <CircularProgress size={20} />
                      ) : (
                        "SAVE"
                      )}
                    </Button>
                  </React.Fragment>
                )}
              </Grid>
            </Grid>
          </div>
        </div>
      </Fade>
    );
  }
}

AdvisorSettings.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const advisorFeeRate = state.fee.advisorFeeRate !== null ? Number(state.fee.advisorFeeRate) : null;
  const advisorDefaultFeeRate = Number(state.fee.advisorDefaultFeeRate);
  return {
    app: state.app,
    user: state.user,
    accessLevel: state.user.user.userRole && state.user.user.userRole.accessLevel ? state.user.user.userRole.accessLevel : 0,
    portfolio: state.portfolio,
    advisorFeeRate,
    advisorDefaultFeeRate,
    appName: state.app.appName,
  };
};
export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps)(AdvisorSettings)
);



// WEBPACK FOOTER //
// ./src/containers/AdvisorSettings/index.jsx